/**
 * PowerSaving – SVG icon.
 */
import Screen from '@screen';

export default function PowerSavingIcon({
  width,
  height,
  margin,
}: {
  width?: number;
  height?: number;
  margin?: string;
}) {
  return (
    <svg
      width={(width ? width : 62) * Screen.widthRatio}
      height={(height ? height : 87) * Screen.widthRatio}
      viewBox='0 0 62 87'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.726 28.1775H16.908V30.9955C16.908 35.6573 20.7002 39.4495 25.362 39.4495H28.18V36.6315C28.18 31.9699 24.3878 28.1775 19.726 28.1775Z'
        fill='url(#paint0_linear_settings_powerSaving)'
      />
      <path
        d='M50.8381 7.17465C32.8151 -7.84366 4.53179 1.87689 0.471881 25.5374C-1.47284 36.8809 2.66623 47.929 11.542 55.0906C14.9545 57.8443 16.912 62.0723 16.912 66.6909V72.3269C16.912 76.9887 20.7042 80.7809 25.366 80.7809H28.184V83.5989C28.184 85.1556 29.4462 86.4169 31.002 86.4169C32.5577 86.4169 33.82 85.1556 33.82 83.5989V80.7809H36.638C41.2998 80.7809 45.092 76.9887 45.092 72.3269V66.6909V66.6899C45.092 66.6895 45.092 66.6894 45.092 66.6894C45.092 62.0823 47.0642 57.8424 50.5023 55.0575C57.8096 49.1437 62 40.3732 62 30.9963C62 21.7701 57.9308 13.0876 50.8381 7.17465ZM39.456 72.3269C39.456 73.8807 38.1918 75.1449 36.638 75.1449H25.366C23.8122 75.1449 22.548 73.8807 22.548 72.3269V69.5089H39.456V72.3269ZM50.728 30.9963C50.728 38.7659 44.4076 45.0863 36.638 45.0863H33.82V63.8729H28.184V45.0863H25.366C17.5963 45.0863 11.276 38.7659 11.276 30.9963V25.3603C11.276 23.8036 12.5383 22.5423 14.094 22.5423H19.73C24.3417 22.5423 28.4301 24.779 31.002 28.2138C33.5739 24.7789 37.6622 22.5423 42.274 22.5423H47.91C49.4657 22.5423 50.728 23.8036 50.728 25.3603V30.9963Z'
        fill='url(#paint1_linear_settings_powerSaving)'
      />
      <path
        d='M42.2857 28.1775C37.6239 28.1775 33.8317 31.9697 33.8317 36.6315V39.4495H36.6497C41.3114 39.4495 45.1037 35.6573 45.1037 30.9955V28.1775H42.2857Z'
        fill='url(#paint2_linear_settings_powerSaving)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_settings_powerSaving'
          x1='22.544'
          y1='28.1775'
          x2='22.544'
          y2='39.4495'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_settings_powerSaving'
          x1='31'
          y1='0'
          x2='31'
          y2='86.4169'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_settings_powerSaving'
          x1='39.4677'
          y1='28.1775'
          x2='39.4677'
          y2='39.4495'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
      </defs>
    </svg>
  );
}
